// src/utils/buildDealFromLead.js
// Pure, Firebase-free: maps a converted buyer lead (+ confirmed property/price)
// into the `newdata` shape the `deals` collection expects. Task seeding is left
// to the caller (buildDealBackfill) so this stays pure and unit-testable.
//
// A converted deal must be SHAPE-COMPATIBLE with a normal turn-in deal so every
// deals view (board, transactions, commission breakdown, approval inbox) reads
// it safely. The financial fields are blank here and get filled in when the
// deal is reviewed/approved — exactly like a brand-new turn-in awaiting input.

import { listClients } from "./leadClients";

export function buildDealFromLead(lead = {}, overrides = {}, { user = {}, nowId } = {}) {
  return {
    // --- Identity / routing ---
    status: "Pending",
    requestType: "saleTurnIn",
    dealtype: "Buyer",
    dealStage: "Under Contract",
    createdby: user.id || "",
    createdat: nowId,
    sourceLeadId: lead.id || "",

    // --- Carried over from the lead + the conversion dialog ---
    // Every client on the lead — primary AND co-clients — not just the first.
    customers: listClients(lead).map((c) => c.contactId),
    agentData: lead.assignedAgent || "",
    agentName: lead.assignedAgentName || "",
    // Prefer a resolved system lead-source OBJECT from the caller (deals store
    // the full object); fall back to the lead's raw value — buyer leads keep it
    // in `leadSource`, listing leads in `source`.
    leadsource:
      overrides.leadsource !== undefined
        ? overrides.leadsource
        : lead.leadSource || lead.source || "",
    propertyaddress: overrides.propertyaddress || "",
    offerPrice: overrides.offerPrice || "",

    // --- Standard deal fields kept present (blank until approval/edit) so no
    //     deals view ever hits `undefined` on a converted deal ---
    closingdate: "",
    propertyphoto: [],
    propertyType: "",
    propertyLocation: null,
    financingType: "",
    earnestMoney: "",
    inspection: "",
    inspectionDeadline: "",
    financingDeadline: "",

    // Commission / split (filled in during approval)
    totalcommissionrate: "",
    agentCommission: "",
    agentCommissionamount: "",
    agentdiscount: 0,
    leadCommission: "",
    splittype: "",
    splitdescription: "",
    inhousereferral: false,
    teamleadName: "",
    assignedteamlead: "",

    // --- Tasks (seeded by buildDealBackfill in the caller) ---
    tasks: [],
    taskStatusTracker: {},
  };
}
